const createEvent = (
	eventType: string,
	eventConstructor = 'Event',
	bubbles = true,
	cancelable = true,
) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const event: Event = document.createEvent(eventConstructor);
	event.initEvent(eventType, bubbles, cancelable);
	return event;
};

export default createEvent;
